import { render, staticRenderFns } from "./VUploadCAF.vue?vue&type=template&id=8c4c9e30"
import script from "./VUploadCAF.vue?vue&type=script&lang=js"
export * from "./VUploadCAF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c4c9e30')) {
      api.createRecord('8c4c9e30', component.options)
    } else {
      api.reload('8c4c9e30', component.options)
    }
    module.hot.accept("./VUploadCAF.vue?vue&type=template&id=8c4c9e30", function () {
      api.rerender('8c4c9e30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commons/VUploadCAF.vue"
export default component.exports